import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':id',
    loadComponent: () =>
      import('./pages/visor-ronda/visor-ronda.component').then(
        (m) => m.VisorRondaComponent,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/inicio/inicio.component').then((m) => m.InicioComponent),
  },
  { path: '**', redirectTo: '' },
];
